import React, {
  FC,
  useCallback,
  useRef,
  useState,
} from "react";
//@ts-ignore
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper";
import 'swiper/css';
import Button, { ButtonModeE } from "../../components/Button/Button";
import { clss } from "../../utils/helpers/styleHelpers";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../store/hooks";
import { selectDirection } from "../../store/selectors/appSelectors";
import { RoutesE } from "../../routes/routesData";
import About from "../../components/About/About";
import { H2, P } from "../../components/Text/Text";
import {
  adv1,
  adv2,
  adv3,
  adv4,
  adv5,
  adv6,
  adv7,
  adv8,
  adv9,
  post1,
  post2,
  post3,
  post4,
  post5,
  post6,
  post7,
  post8,
  post9,
  broad1,
  broad2,
  broad3,
  broad4,
  broad5,
  broad6,
} from "../../assets/images";
import Tooltip from "../../components/Tooltip/Tooltip";
import { TimeoutId } from "@reduxjs/toolkit/dist/query/core/buildMiddleware/types";
import { isMobileOrTablet } from "../../utils/helpers/mediaQueries";

import styles from "./home.module.scss";

const CLIENT_SLIDE_DELAY = 5000;

const Home = () => {
  const advertiserClientList = [
    {
      img: adv1,
      tooltip: "1",
    },
    {
      img: adv2,
      tooltip: "2",
    },
    // {
    //     img: adv3,
    //     tooltip: '2 be removed'
    // },
    {
      img: adv4,
      tooltip: "BBR Saatchi & Saatchi",
    },
    {
      img: adv5,
      tooltip: "Gitam BBDO",
    },
    {
      img: adv6,
      tooltip: "JWT",
    },
    {
      img: adv7,
      tooltip: "McCANN",
    },
    {
      img: adv8,
      tooltip: "Public",
    },
    {
      img: adv9,
      tooltip: "Y & R",
    },
  ];

  const postClientList = [
    // {
    //     img: post1,
    //     tooltip: 'Zarmon'
    // },
    {
      img: post2,
      tooltip: "Bassline Sound Design",
    },
    {
      img: post3,
      tooltip: "Broadcast",
    },
    {
      img: post4,
      tooltip: "Gravity Creative Tech",
    },
    {
      img: post5,
      tooltip: "Green Production",
    },
    {
      img: post6,
      tooltip: "Market Master",
    },
    {
      img: post7,
      tooltip: "Soundhouse",
    },
    {
      img: post8,
      tooltip: "Signal",
    },
    {
      img: post9,
      tooltip: "10 fingers",
    },
  ];

  const broadcasterClientList = [
    {
      img: broad1,
      tooltip: "Reshet TV",
    },
    {
      img: broad2,
      tooltip: "Keshet TV",
    },
    {
      img: broad3,
      tooltip: "Kan 11",
    },
    {
      img: broad4,
      tooltip: "Channel 14",
    },
    {
      img: broad5,
      tooltip: "24",
    },
    {
      img: broad6,
      tooltip: "9 TV",
    },
  ];

  const navigate = useNavigate();
  const direction = useAppSelector(selectDirection);
  const [selectedClientList, setSelectedClientList] = useState(0);
  const [clientList, setClientList] = useState(advertiserClientList);
  const interval = useRef<TimeoutId>();

  // useEffect(() => {
  //     interval.current = setInterval(() => {
  //         if (!isMobileOrTablet()) {
  //             setSelectedClientList(prev => prev === 2 ? 0 : prev + 1);
  //         }
  //     }, CLIENT_SLIDE_DELAY);

  //     return () => {
  //         clearInterval(interval.current);
  //     }
  // }, []);

  // useEffect(() => {
  //     switch (selectedClientList) {
  //         case 0: return setClientList(advertiserClientList);
  //         case 1: return setClientList(postClientList);
  //         case 2: return setClientList(broadcasterClientList);
  //     }
  // }, [selectedClientList]);

  const navigateToContact = () => {
    navigate(RoutesE.CONTACT_US);
  };

  const navigateToLogin = () => {
    navigate(RoutesE.LOGIN);
  };

  const handleMouseEnter = useCallback(() => {
    clearInterval(interval.current);
  }, []);

  const handleMouseLeave = useCallback(() => {
    interval.current = setInterval(() => {
      if (!isMobileOrTablet()) {
        setSelectedClientList((prev) => (prev === 2 ? 0 : prev + 1));
      }
    }, CLIENT_SLIDE_DELAY);
  }, []);

  const handleInit = useCallback(() => {
    const firstStepText = document.getElementById(`step-text-0`);
    if (firstStepText) {
      firstStepText.classList.add(styles.animationSlideInTop);
    }
  }, []);

  const SliderButtons: FC<{ link: string }> = useCallback(({ link }) => {
    const handleNavigate = () => {
      if (link === RoutesE.ABOUT) {
        const aboutElement = document.getElementById("about");

        aboutElement.scrollIntoView({
          behavior: "smooth",
        });
      } else {
        navigate(link);
      }
    };
    return (
      <div className={styles.buttons}>
        <Button
          mode={ButtonModeE.OUTLINED}
          onClick={handleNavigate}
          link={link === RoutesE.ABOUT ? undefined : link}
        >
          Learn more
        </Button>
        <Button onClick={navigateToContact} link={RoutesE.CONTACT_US}>
          Contacts us
        </Button>
      </div>
    );
  }, []);

  return (
    <div className={styles.mainWrapper}>
      <Swiper
        key={direction}
        pagination={{ clickable: true }}
        modules={[Pagination, Autoplay]}
        grabCursor
        onInit={handleInit}
        loop
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
      >
        <SwiperSlide>
          <div className={clss([styles.stepWrapper, styles.step1])}>
            <div className={styles.stepText} id="step-text-0">
              <h3>
                Ad Delivery <span>at its Best</span>
              </h3>
              <div className={styles.description}>
                <p>One platform streamlining advertising</p>
                <p>workflow from beginning to end</p>
              </div>
              <SliderButtons link={RoutesE.ABOUT} />
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <>{({ isActive }) => <p>{isActive ? "active" : "not active"}</p>}</>
          <div className={clss([styles.stepWrapper, styles.step2])}>
            <div className={styles.stepText} id="step-text-1">
              <h3>
                Simple <span>Advertising Workflow</span>
              </h3>
              <div className={styles.description}>
                <p>With automated delivery of each and every ad</p>
              </div>
              <SliderButtons link={RoutesE.FEATURES} />
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <>{({ isActive }) => <p>{isActive ? "active" : "not active"}</p>}</>
          <div className={clss([styles.stepWrapper, styles.step3])}>
            <div className={styles.stepText} id="step-text-2">
              <h3>
                Connecting <span>Everyone</span>
              </h3>
              <div className={styles.description}>
                <p>
                  Advertising agencies, post production companies and
                  broadcasters
                </p>
              </div>
              <SliderButtons link={RoutesE.PROCESS} />
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
      <About />
      <div className={styles.clientSection}>
        <H2>Our Clients</H2>
        <P>
          JumboMedia dominates the Israeli TV advertising market with hundreds
          of companies using our system. It is used by all TV channels and
          broadcasters, as well as most post-production companies and
          advertisers.
        </P>
        <div>
          <ul className={styles.clientListTabs}>
            <li
              className={selectedClientList === 0 ? styles.selected : ""}
              onClick={() => setSelectedClientList(0)}
            >
              Advertising agencies
            </li>
            <li
              className={selectedClientList === 1 ? styles.selected : ""}
              onClick={() => setSelectedClientList(1)}
            >
              Post-production
            </li>
            <li
              className={selectedClientList === 2 ? styles.selected : ""}
              onClick={() => setSelectedClientList(2)}
            >
              Broadcasters
            </li>
          </ul>
          <ul
            className={styles.clientList}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            {clientList.map((el) => (
              <li key={el.tooltip}>
                <Tooltip text={el.tooltip}>
                  <img src={el.img} alt={el.tooltip} />
                </Tooltip>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className={styles.footer}>
        <P>Manage and deliver video ads to broadcasters</P>
        <P>in one whole eco-system.</P>
        <Button onClick={navigateToLogin}>Get started</Button>
      </div>
    </div>
  );
};

export default Home;
